/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Meta_Shown_Events_AllInputs */



/**
* | totalPlural | output |
* | --- | --- |
* | "one" | "{totalFormatted} archived event" |
* | * | "{totalFormatted} archived events" |
*
* @param {Meta_Shown_Events_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_shown_events_all = /** @type {((inputs: Meta_Shown_Events_AllInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Shown_Events_AllInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const totalPlural = registry.plural("de", i?.total, {}, true);
		const totalFormatted = registry.number("de", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} Event im Archiv`);
		return /** @type {LocalizedString} */ (`${totalFormatted} Events im Archiv`)
	}
	if (locale === "fr") {
		const totalPlural = registry.plural("fr", i?.total, {}, true);
		const totalFormatted = registry.number("fr", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} événement archivé`);
		return /** @type {LocalizedString} */ (`${totalFormatted} événements archivés`)
	}
	if (locale === "zh-Hans") {
		const totalPlural = registry.plural("zh-Hans", i?.total, {}, true);
		const totalFormatted = registry.number("zh-Hans", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted}场已归档赛事`);
		return /** @type {LocalizedString} */ (`${totalFormatted}场已归档赛事`)
	}
	if (locale === "zh-Hant") {
		const totalPlural = registry.plural("zh-Hant", i?.total, {}, true);
		const totalFormatted = registry.number("zh-Hant", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 場已歸檔賽事`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 場已歸檔賽事`)
	}
	if (locale === "ko") {
		const totalPlural = registry.plural("ko", i?.total, {}, true);
		const totalFormatted = registry.number("ko", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`아카이브된 이벤트 ${totalFormatted}개`);
		return /** @type {LocalizedString} */ (`아카이브된 이벤트 ${totalFormatted}개`)
	}
	{
		const totalPlural = registry.plural("en", i?.total, {}, true);
		const totalFormatted = registry.number("en", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} archived event`);
		return /** @type {LocalizedString} */ (`${totalFormatted} archived events`)
	}
});